// extracted by mini-css-extract-plugin
export default {"cls1":"CreateSocialItem-cls1___d51925c807aeaf9cda7","cls2":"CreateSocialItem-cls2___45e8965f77ff30d6482 CreateSocialItem-cls1___d51925c807aeaf9cda7"};